import { render } from "./PieDiagram.vue?vue&type=template&id=0d43256c"
import script from "./PieDiagram.vue?vue&type=script&lang=js"
export * from "./PieDiagram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__